<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title title" id="confiramtionLabel">
        Delete Confirmation Dialog
      </h5>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
        id="closeConfirmationModalButton"
      ></button>
    </div>
    <div class="modal-body">
      Are you sure you want to delete
      {{ selectedUser?.displayName }}?<br /><br />
      Please enter the user's email address below and click the Confirm button.
      <div class="mt-3 mb-3">
        <input
          type="email"
          class="form-control"
          id="email"
          placeholder="john.doe@domain"
          [(ngModel)]="mail"
          (ngModelChange)="checkIfEmailEntered()"
          name="mail"
        />
      </div>
    </div>

    <div class="modal-footer">
      <div class="secondary float-end" data-bs-dismiss="modal">
        <div class="discard valign-text-middle">
          <span>Cancel</span>
        </div>
      </div>
      <div
        *ngIf="isEmailEntered"
        class="primary float-end ms-2"
        (click)="delete()"
      >
        <div class="confirm valign-text-middle">
          <span
            ><span *ngIf="!isDeleting">Confirm</span>
            <div
              *ngIf="isDeleting"
              class="loading-delete d-flex justify-content-center mt-3"
            ></div
          ></span>
        </div>
      </div>
      <div *ngIf="!isEmailEntered" class="frame-3952 float-end ms-2">
        <div class="disabled-save valign-text-middle">
          <span> Confirm </span>
        </div>
      </div>
    </div>
  </div>
</div>
